import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { PricePriceDimensionTypeModel } from "../../models/reference-model/reference-general-model/price-price-dimension-type.model";

@Injectable({
    providedIn: 'root'
})
export class PricePriceDimensionTypeService extends ApiServiceBase {
    private readonly REFERENCE_PATH = '/system/pricePriceDimensionTypes'
    constructor(httpClient: HttpClient, authService: AuthService) {
        super(httpClient, authService);
    }

    public getPricePriceDimensionTypes(): Observable<PricePriceDimensionTypeModel[]> {
        return this.httpGet<PricePriceDimensionTypeModel[]>(this.REFERENCE_PATH, null)
            .pipe(
                map(
                    res => res.body
                )
            )
    }
}